import React from 'react';
import Grid from '@material-ui/core/Grid';
import get from 'get-value';
import classNames from 'classnames';
import { BUTTON_MODS } from '../interface';
import { Select as CustomSelect } from 'shared/Inputs';
import Button from 'shared/Button/Button';
import { Option } from 'shared/interface/globalInterface';
import './_FormInputNewUi.scss';

type Props = {
  options: Option[];
  mode: BUTTON_MODS;
  field: any;
  form: any;
  placeholderText?: string;
  tight?: boolean;
  noOptionsText?: string;
  searchable?: boolean;
};

const FormSelectNewUi: React.FC<Props> = ({
  field,
  form,
  options,
  mode = BUTTON_MODS.ADD,
  placeholderText = 'Please select...',
  searchable,
  ...props
}) => {
  const { name } = field;
  const { touched, errors } = form;
  const {
    label,
    labelClass = 'form__label',
    helperText,
    inputWidth = 12,
    spacing = 1,
    wrapperClass = 'form__wrapper_newUi inline',
    showBorder = true,
    required,
    onClick,
    buttonWidth = 4,
    buttonClass = '',
    disableButton = false,
    error,
    tight = false,
    noOptionsText,
    readOnly = false,
  } = props as any;
  const changeButtonText = BUTTON_MODS[mode];
  const buttonClassName = classNames('button', buttonClass);

  const nestedError = get(errors, name);
  const nestedTouched = get(touched, name);

  const containerClass = classNames(wrapperClass, {
    'form__field-error': nestedTouched && nestedError,
    'no-border': !showBorder,
  });

  const inputWrapperClass = classNames('form__input-wrapper', {
    'no-border': !showBorder,
  });

  const selected = field.value ? field.value.value : '';
  const selectedOption = options.find((o) => o.value === selected);
  const selectedLabel = selectedOption ? selectedOption.option : '';

  const handleSelected = (option: any) => {
    form.setFieldTouched(field.name);
    form.setFieldValue(field.name, { value: option.value, id: option.id, option: option.option });
  };

  const handleChangeClick = (...props: any) => {
    onClick(mode === BUTTON_MODS.CHANGE ? BUTTON_MODS.OK : BUTTON_MODS.CHANGE, ...props);
  };

  const hasError = error || (nestedTouched && nestedError);

  return (
    <div className={containerClass}>
      <div className={inputWrapperClass}>
        <label htmlFor={name} className={`${labelClass} form__inline-label`}>
          {label}
        </label>
        {helperText && <div className="form__helper-text">{helperText}</div>}
        <Grid container spacing={spacing} alignItems="center" wrap="nowrap">
          <Grid item xs={inputWidth} className="form-grid__item--small">
            <select hidden={true} id={name} {...field}>
              <option disabled value="" className="placeholder">
                {placeholderText}
              </option>
              {options.map((option) => (
                <option key={option.id || option.value} value={option.value}>
                  {option.value}
                </option>
              ))}
            </select>

            <CustomSelect
              options={options}
              name={field.name}
              onSelected={handleSelected}
              disabled={readOnly}
              selected={{ value: selected, label: selectedLabel }}
              isRequired={required}
              inline={true}
              placeholderText={placeholderText}
              tight={tight}
              variant="newUi"
              noOptionsText={noOptionsText}
              searchable={searchable}
            />
          </Grid>
          {onClick && (
            <Grid item xs={buttonWidth} className="form-grid__item--small">
              <Button
                onClick={handleChangeClick}
                label={changeButtonText}
                className={buttonClassName}
                disabled={disableButton}
              />
            </Grid>
          )}
        </Grid>
        {hasError && <div className="error-message coral">{error || nestedError}</div>}
      </div>
    </div>
  );
};

export default FormSelectNewUi;
